<template>
  <div
    class="relative mx-auto grid w-fit grid-flow-col place-content-center gap-3 p-5 text-new-red-dark"
  >
    <TransitionGroup name="list">
      <template v-if="page > offset && !paginatePages.includes(1)">
        <NuxtLink
          :key="`1-first`"
          class="w-fit cursor-pointer"
          :to="{ query: { ...route.query, page: 1 } }"
          >1</NuxtLink
        >
        <div v-if="page - offset > offset - 1" class="cursor-default">...</div>
      </template>
      <template v-for="i in paginatePages" :key="`${i}-middle`">
        <NuxtLink
          class="w-fit cursor-pointer"
          :class="{
            'rounded-md bg-article/10 px-2 font-bold': viewPage === i,
          }"
          :to="{ query: { ...route.query, page: i } }"
        >
          {{ i }}
        </NuxtLink>
      </template>
      <template v-if="page < totalPages - offset">
        <div v-if="totalPages - page > offset + 1" class="cursor-default">
          ...
        </div>
        <NuxtLink
          :key="`${totalPages}-last`"
          class="w-fit cursor-pointer"
          :to="{ query: { ...route.query, page: totalPages } }"
        >
          {{ totalPages }}
        </NuxtLink>
      </template>
    </TransitionGroup>
  </div>
</template>

<script setup>
defineProps({
  page: {
    type: Number,
    required: true,
  },
  totalPages: {
    type: Number,
    required: true,
  },
  viewPage: {
    type: Number,
    required: true,
  },
  paginatePages: {
    type: Array,
    required: true,
  },
  offset: {
    type: Number,
    default: 3,
  },
});

const route = useRoute();

// const localSelectPage = computed(() => {
//   const page = +route.query.page || 1;
//   if (page === props.viewPage) return props.viewPage;
//   return page;
// });
</script>

<style>
.list-move,
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-leave-active {
  display: none;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.list-leave-active {
  position: absolute;
  inset: 0;
}
</style>
